import { useSearchParams } from 'react-router-dom';

import { toggleType, typesFromParams, typesParam, type SaleType } from './daily-sales-filters';

/**
 * Which sale types and region the Daily sales page shows, kept in the address
 * (`?types&region`) beside the dates so a shared link opens the same view. Every type
 * and every region leave them out of the address.
 */
export function useDailySalesFilters() {
  const [params, setParams] = useSearchParams();
  const types = typesFromParams(params);
  const regionId = params.get('region') || null;

  const update = (key: string, value: string | null) => {
    setParams((current) => {
      const out = new URLSearchParams(current);
      if (value) out.set(key, value);
      else out.delete(key);
      return out;
    });
  };

  return {
    types,
    regionId,
    toggleType: (type: SaleType) => update('types', typesParam(toggleType(types, type))),
    setRegion: (id: string | null) => update('region', id),
  };
}
